import styled from 'styled-components';

export default styled.main`
  position: relative;
  width: 100%;
  height: 100%;
`;
